import retard_CEO from '../data/blogimg/retard_CEO.avif';
import suno from '../data/blogimg/suno.jpg';

export default function Blog() {
  return (
    <main className='page'>
      <section className='blogContainer'>
        <article>
          <h1>Låt bli</h1>
          <span className='blogDate'>JUL 7, 2026</span>

          <p>
            Life oozes in from all sides.
          </p>
        </article>

        <div className='separator'> ✢ ✣ ✤ ✥ </div>

        <article>
          <h1>A Skull Full of Maggots</h1>
          <span className='blogDate'>JUL 7, 2026</span>

          <p>
            When Alex Webster argues that death metal fans enjoy Cannibal Corpse's music only because they know the violence depicted in its lyrics is not real, he's really saying
            his band is a snuff film and that metal is something juvenile you just tune into when you feel like it. Unserious lyrics are fine, but if your bandmate
            George says he would lose his mind if in real life he faced the violence depicted in their own lyrics, then maybe you should write about something else.
          </p>
        </article>

        <div className='separator'> ✢ ✣ ✤ ✥ </div>

        <article>
          <h1>Update on new material #2</h1>
          <span className='blogDate'>JUN 21, 2026</span>

          <p>
            Starting to write new lyrics for change. Half of my guitar riff ideas I get and juggle in my head when
            I'm trying to sleep by the way. Only half when jamming on the guitar.
          </p>
        </article>

        <div className='separator'> ✢ ✣ ✤ ✥ </div>

        <article>
          <h1>Update on new material</h1>
          <span className='blogDate'>MAY 6, 2026</span>

          <p>
            I have been working on other musical projects and it has taken focus away from Tegara,
            but the tones are more or less ready and there are three project files of unfinished songs,
            two of which can be heard in the clip on SoundCloud.
          </p>
        </article>

        <div className='separator'> ✢ ✣ ✤ ✥ </div>

        <article>
          <h1>Fatigue #2</h1>
          <span className='blogDate'>JAN 8, 2026</span>

          <p className='onlyImage'>
            <img className='blogImg'
              src={suno}
              alt='comic of an AI "producer" getting humiliated'
            />
          </p>

          <p>
            ▷ <a href="https://www.change.org/p/give-users-control-let-us-turn-off-ai-generated-content" rel="noreferrer" target="_blank">Give Users Control: Let Us Turn Off AI-Generated Content (change.org)</a><br />
            ▷ <a href="https://www.change.org/search?q=artificial+intelligence" rel="noreferrer" target="_blank">Explore more such petitions (change.org)</a>
          </p>
        </article>

        <article>
          <h1>Fatigue</h1>
          <span className='blogDate'>JAN 7, 2026</span>

          <p className='onlyImage'>
            <img className='blogImg'
              src={retard_CEO}
              alt='screenshot of a guy rightfully complaining about his CEO falling for AI hype'
            />
          </p>
        </article>
      </section>
    </main>
  );
}
